import feathericons from 'feather-icons'

export default function (_, inject) {
	inject('feathericons', feathericons.icons)
}
